'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button data-component-id="src/components/common/BackToTop.tsx:33:8" data-component-path="src/components/common/BackToTop.tsx" data-component-line="33" data-component-end-line="39" data-component-file="BackToTop.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22fixed%20bottom-8%20right-8%20z-50%20p-3%20bg-primary%20text-primary-foreground%20rounded-full%20shadow-lg%20hover%3Abg-primary%2F90%20transition-all%20duration-300%20hover%3Ascale-110%22%7D"
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 p-3 bg-primary text-primary-foreground rounded-full shadow-lg hover:bg-primary/90 transition-all duration-300 hover:scale-110"
          aria-label="Back to top"
        >
          <Icon data-component-id="src/components/common/BackToTop.tsx:38:10" data-component-path="src/components/common/BackToTop.tsx" data-component-line="38" data-component-end-line="38" data-component-file="BackToTop.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChevronUpIcon%22%7D" name="ChevronUpIcon" size={24} />
        </button>
      )}
    </>
  );
};

export default BackToTop;